module.exports = exports = require('./ArrayUtils');
exports.getEquallySpacedData = require('./getEquallySpaced').getEquallySpacedData;
exports.SNV = require('./snv').SNV;
exports.binarySearch = require('ml-binary-search');



//////////////////
// WEBPACK FOOTER
// ./~/nmr-simulation/~/ml-array-utils/src/index.js
// module id = 105
// module chunks = 0